import type { SxProps, Theme } from "@mui/material";

export const counterStyle: SxProps = {
  mr: 2,
  ml: "auto",
  whiteSpace: "nowrap",
  minWidth: 100,
  textAlign: "right",
  cursor: "pointer",
};

// SearchBar
export const searchBarStyle: SxProps = {
  marginTop: 2,
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  zIndex: 1100,
};

export const searchBarInnerStyle: SxProps = (theme: Theme) => ({
  display: "flex",
  width: "100%",
  p: 1,
  background: theme.palette.box1.main,
  borderRadius: 2,
  boxShadow: 1,
  color: theme.palette.box1.contrastText,
  alignItems: "center",
});

export const buttonGroupStyle: SxProps = {
  mr: 2,
};
